import * as moment from 'moment';

import { keyCheck } from '../../helper/object-helper';

import BaseEntity from '../base-entity';

export default class PackageInfo extends BaseEntity {
  constructor(obj) {
    super(obj);
    this.companyName = keyCheck(obj, 'companyName') ? obj.companyName : '';
    this.companyDisplayName = keyCheck(obj, 'companyDisplayName') && !!obj.companyDisplayName ? obj.companyDisplayName : this.companyName;
    this.securityCode = keyCheck(obj, 'securityCode') && !!obj.securityCode && !!Number(obj.securityCode) ? Number(obj.securityCode) : 0;
    this.industryCategory = keyCheck(obj, 'industryCategory') ? obj.industryCategory : '';
    this.companyImageUrl = keyCheck(obj, 'companyImageUrl') ? obj.companyImageUrl : '';
    this.companyUrl = keyCheck(obj, 'companyUrl') ? obj.companyUrl : '';
    this.foundationDate = keyCheck(obj, 'foundationDate') ? Number(moment(obj.foundationDate).format('x')) : 0;
    this.caseStudy = keyCheck(obj, 'caseStudy') ? obj.caseStudy : '';
    this.linkedProject = keyCheck(obj, 'linkedProject') ? obj.linkedProject : '';
    // eslint-disable-next-line no-restricted-globals
    this.fiscalEndMonth = keyCheck(obj, 'fiscalEndMonth') && obj.fiscalEndMonth && isFinite(obj.fiscalEndMonth) ? obj.fiscalEndMonth : '';
  }

  static default() {
    return new PackageInfo();
  }
}
